import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PartialMessageProps } from '../partial-message/PartialMessage';
import {
  WatchlistEntityMatchesTable,
  WatchlistEntityMatchesTableProps,
} from '../watchlist-entity-matches-table/WatchlistEntityMatchesTable';
import * as S from '../WatchlistMessage.styles';

export interface MultipleEntityMatchesReplyProps {
  action: string;
  items: [Record<string, string[]>];
  info: Pick<PartialMessageProps, 'data'>['data']['info'];
  onAddToWatchlist?: WatchlistEntityMatchesTableProps['onAddToWatchlist'];
}

export const MultipleEntityMatchesReply: FC<
  MultipleEntityMatchesReplyProps
> = ({ items, info, action, onAddToWatchlist }) => {
  const { t } = useTranslation('intel');
  const { name, id = '', entities = [] } = info;

  return (
    <>
      <S.ReplyMessage>
        {
          /* i18next-extract-disable-next-line */
          t(`intel:watchlist.partial.${action}.multiple-entity-matches`, {
            count: items.length + entities.length,
            entities,
            name,
          })
        }
      </S.ReplyMessage>
      {items.map(assets => {
        return Object.entries(assets).map(asset => {
          const [item, suggestions] = asset;
          return (
            <WatchlistEntityMatchesTable
              key={item}
              tags={suggestions}
              onAddToWatchlist={onAddToWatchlist}
              watchlistId={id}
              watchlistName={name}
              name={item}
            />
          );
        });
      })}
    </>
  );
};
